<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <div class="d-flex align-items-center justify-content-end mb-3">
        <a
          href="javascript:void(0)"
          @click="$router.go(-1)"
        >
          <CIcon
            name="cil-arrow-left"
            class="mr-2"
          />Voltar
        </a>
      </div>

      <CForm @submit.prevent="send">
        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Produto' : 'Cadastrar Produto' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <!-- Highlight -->
                  <label class="mb-0">
                    <b>Destaque</b>
                  </label>

                  <CSwitch
                    type="checkbox"
                    color="warning"
                    variant="3d"
                    class="mx-2 mr-md-4"
                    v-bind="labelIcon"
                    :checked.sync="form.favorite"
                  />

                  <!-- Status -->
                  <label class="mb-0">
                    <b>Status</b>
                  </label>
                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <CRow>
                      <!-- Category -->
                      <CCol lg="4">
                        <div class="form-group">
                          <label for="">Categoria*</label>

                          <Multiselect
                            :value="categoriesOptions.find(option => option.value == form.category)"
                            :options="categoriesOptions"
                            label="label"
                            track-by="value"
                            :disabled="processing"
                            @select="(selected) => form.category = selected.value"
                          />
                        </div>
                      </CCol>

                      <!-- Subcategory -->
                      <CCol lg="4">
                        <div class="form-group">
                          <label for="">Subcategoria*</label>

                          <Multiselect
                            :value="subcategoriesOptions.find(option => option.value == form.sub_category)"
                            :options="subcategoriesOptions"
                            label="label"
                            track-by="value"
                            :disabled="processing"
                            placeholder="Selecione uma categoria"
                            @select="(selected) => form.sub_category = selected.value"
                          />
                        </div>
                      </CCol>

                      <!-- Code-->
                      <CCol lg="4">
                        <CInput
                          id="first"
                          v-model="form.code"
                          label="Código*"
                          :disabled="processing"
                        />
                      </CCol>
                    </CRow>

                    <CRow>
                      <!-- Title -->
                      <CCol lg="4">
                        <CInput
                          v-model="form.title"
                          label="Título*"
                          :disabled="processing"
                        />
                      </CCol>

                      <!-- Link Yt -->
                      <CCol lg="4">
                        <CInput
                          v-model="form.installation_tutorial"
                          :disabled="processing"
                          type="url"
                          description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                        >
                          <template #label>
                            <label>Tutorial de instalação <small class="text-muted">(URL Youtube)</small></label>
                          </template>
                        </CInput>
                      </CCol>
                    </CRow>

                    <!-- Description -->
                    <CRow>
                      <CCol lg="12">
                        <div class="form-group">
                          <label for="mission">Descrição*</label>

                          <TextEditor
                            id="mission"
                            v-model="form.description"
                            type="simpletext"
                            :disabled="processing"
                          />
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>

                <!-- Related Products -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Produtos/Aplicações Relacionadas
                  </h5>
                </div>

                <CRow>
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="">Produtos relacionados</label>

                      <Multiselect
                        id=""
                        :value="productsOptions.filter((option) => form.related.includes(option.value))"
                        :options="productsOptions"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="1"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) => form.related.push(selected.value)"
                        @remove=" (removed) => form.related.splice(form.related.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>

                  <CCol lg="6">
                    <div class="form-group">
                      <label for="">Ferramentas de aplicação</label>
                      <Multiselect
                        id=""
                        :value="productsOptions.filter((option) => form.application_tools.includes(option.value))"
                        :options="productsOptions"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="1"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) =>form.application_tools.push(selected.value)"
                        @remove=" (removed) => form.application_tools.splice(form.application_tools.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>
                </CRow>

                <!-- Links -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Links
                    <small class="pl-2 pt-1 text-muted">(Inclua abaixo os links relacionados ao produtos, como por exemplo os catálogos, publicações, vídeos e etc.)</small>
                  </h5>
                </div>

                <CRow>
                  <CCol col="12">
                    <ListItem
                      :items="form.links"
                      :fields="fieldsLinks"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- Images -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Imagens
                  </h5>
                </div>

                <CRow>
                  <!-- Image -->
                  <CCol col="12">
                    <div class="form-group">
                      <FileUploader
                        id="product-image"
                        :enable-multiple="false"
                        :uploader-info="{ label: 'Imagem principal*'}"
                        :enable-crop-on-uploader="true"
                        :enable-edit-on-api-table="false"
                        :max-files="1"
                        :accept-types="acceptTypes"
                        :extensions="extensions"
                        :medias="form.main_image"
                        :min-cropped-width="771"
                        :min-cropped-height="428"
                        uploader-type="banner"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>

                  <!-- Gallery -->
                  <CCol col="12">
                    <div class="form-group">
                      <FileUploader
                        id="products-images"
                        :enable-multiple="true"
                        :uploader-info="{ label: 'Galeria de imagens' }"
                        :enable-crop-on-uploader="false"
                        :enable-edit-on-api-table="false"
                        :max-files="25"
                        :accept-types="acceptTypes"
                        :extensions="extensions"
                        :medias="form.medias"
                        :min-cropped-width="771"
                        :min-cropped-height="428"
                        uploader-type="banner"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    SEO
                  </h5>
                </div>

                <CRow>
                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug"
                      :based-on="form.title"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug"
                      model="products"
                      @change="(value) => form.slug = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo"
                  :page-title="form.title"
                  :page-description="form.description"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <!-- Exibition -->
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>
                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="6">
                    <CInput
                      v-model="form.title_en"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol lg="6">
                    <CInput
                      v-model="form.installation_tutorial_en"
                      :disabled="processing"
                      type="url"
                      description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                    >
                      <template #label>
                        <label>Tutorial de instalação <small class="text-muted">(URL Youtube)</small></label>
                      </template>
                    </CInput>
                  </CCol>
                </CRow>

                <!-- Description -->
                <CRow>
                  <CCol>
                    <div class="form-group">
                      <label for="english-description">Descrição*</label>

                      <TextEditor
                        id="english-description"
                        v-model="form.description_en"
                        type="simpletext"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Related products -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Produtos/Aplicações Relacionadas
                      </h5>
                    </div>
                  </CCol>

                  <CCol lg="6">
                    <div class="form-group">
                      <label for="relatedProducts">Produtos relacionados</label>

                      <Multiselect
                        id="relatedProducts"
                        :value="productsOptionsEn.filter((option) => form.related_en.includes(option.value))"
                        :options="productsOptionsEn"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="1"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) => form.related_en.push(selected.value)"
                        @remove=" (removed) => form.related_en.splice(form.related_en.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>

                  <CCol lg="6">
                    <div class="form-group">
                      <label for="applicationTools">Ferramentas de aplicação</label>
                      <Multiselect
                        id="applicationTools"
                        :value="productsOptionsEn.filter((option) => form.application_tools_en.includes(option.value))"
                        :options="productsOptionsEn"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="1"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) => form.application_tools_en.push(selected.value)"
                        @remove=" (removed) => form.application_tools_en.splice(form.application_tools_en.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>
                </CRow>

                <!-- Links -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Links
                        <small class="pl-2 pt-1 text-muted">(Inclua abaixo os links relacionados ao produtos, como por exemplo os catálogos, publicações, vídeos e etc.)</small>
                      </h5>
                    </div>
                  </CCol>

                  <CCol lg="12">
                    <ListItem
                      :items="form.links_en"
                      :fields="fieldsLinks"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_en"
                      :based-on="form.title_en"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_en"
                      model="products"
                      @change="(value) => form.slug_en = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_en"
                  :page-title="form.title_en"
                  :page-description="form.description_en"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <!-- Exibition -->
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>
                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="6">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol lg="6">
                    <CInput
                      v-model="form.installation_tutorial_es"
                      :disabled="processing"
                      type="url"
                      description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                    >
                      <template #label>
                        <label>Tutorial de instalação <small class="text-muted">(URL Youtube)</small></label>
                      </template>
                    </CInput>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol>
                    <div class="form-group">
                      <label for="english-description">Descrição*</label>

                      <TextEditor
                        id="spanish-description"
                        v-model="form.description_es"
                        type="simpletext"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Related products -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Produtos/Aplicações Relacionadas
                      </h5>
                    </div>
                  </CCol>

                  <CCol lg="6">
                    <div class="form-group">
                      <label for="relatedProducts">Produtos relacionados</label>
                      <Multiselect
                        id="relatedProducts"
                        :value="productsOptionsEs.filter((option) => form.related_es.includes(option.value))"
                        :options="productsOptionsEs"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="1"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) => form.related_es.push(selected.value)"
                        @remove=" (removed) => form.related_es.splice(form.related_es.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>

                  <CCol lg="6">
                    <div class="form-group">
                      <label for="applicationTools">Ferramentas de aplicação</label>

                      <Multiselect
                        id="applicationTools"
                        :value="productsOptionsEs.filter((option) => form.application_tools_es.includes(option.value))"
                        :options="productsOptionsEs"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="1"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) =>form.application_tools_es.push(selected.value)"
                        @remove=" (removed) => form.application_tools_es.splice(form.application_tools_es.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>
                </CRow>

                <!-- Links -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Links
                        <small class="pl-2 pt-1 text-muted">(Inclua abaixo os links relacionados ao produtos, como por exemplo os catálogos, publicações, vídeos e etc.)</small>
                      </h5>
                    </div>
                  </CCol>

                  <CCol lg="12">
                    <ListItem
                      :items="form.links_es"
                      :fields="fieldsLinks"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_es"
                      :based-on="form.title_es"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_es"
                      model="products"
                      @change="(value) => form.slug_es = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_es"
                  :page-title="form.title_es"
                  :page-description="form.description_es"
                  :is-edit="!!$route.params.id"
                />
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import Multiselect from '@/components/ui/Multiselect'
import TextEditor from '@/components/ui/TextEditor'
import TabsStatus from '@/components/ui/TabsStatus'
import ListItem from '@/components/ui/ListItem'
import Seo from '@/components/ui/Seo'
import CardLog from '@/components/ui/CardLog'
import FriendlyUrl from '@/components/ui/FriendlyUrl'

import moment from 'moment'
import { cloneDeep } from 'lodash'

import Service from '@/services/products.service'

export default {
  metaInfo: {
    title: 'Produtos',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_products')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Modal,
    Multiselect,
    TextEditor,
    TabsStatus,
    ListItem,
    Seo,
    CardLog,
    FriendlyUrl
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      vertical: false,
      variant: 'tabs',
      item: {
        code: '',
        title: '',
        title_en: '',
        title_es: '',
        slug: '',
        slug_en: '',
        slug_es: '',
        installation_tutorial: '',
        installation_tutorial_en: '',
        installation_tutorial_es: '',
        description: '',
        description_en: '',
        description_es: '',
        favorite: false,
        status: true,
        status_en: false,
        status_es: false,
        links: [],
        links_en: [],
        links_es: [],
        main_image: [],
        medias: [],
        sub_category: '',
        category: '',
        related: [],
        related_en: [],
        related_es: [],
        application_tools: [],
        application_tools_en: [],
        application_tools_es: [],
        seo: {
          seo_title: '',
          seo_description: ''
        },
        seo_en: {
          seo_title: '',
          seo_description: ''
        },
        seo_es: {
          seo_title: '',
          seo_description: ''
        }
      },
      form: {
        related: [],
        application_tools: [],
        related_en: [],
        application_tools_en: [],
        related_es: [],
        application_tools_es: []
      },
      productsOptions: [],
      productsOptionsEn: [],
      productsOptionsEs: [],
      categoriesOptions: [],
      subcategoriesOptions: [],
      links: [],
      fieldsLinks: [
        {
          key: 'title',
          label: 'Título',
          type: 'text',
          required: true,
          disabled: false,
          placeholder: 'Digite o título',
          _classes: 'col-lg-5',
          _style: ''
        },
        {
          key: 'url',
          label: 'URL',
          type: 'link',
          required: true,
          disabled: false,
          placeholder: 'Digite o link',
          _classes: 'col-lg-5',
          _style: ''
        }
      ],
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      productMedia: [],
      productsGalleryMedia: [],
      seo: {},
      englishRelatedProductsSelected: [],
      englishAplicationsToolsSelected: [],
      englishLinks: [],
      englishSeo: {},
      spanishRelatedProductsSelected: [],
      spanishAplicationsToolsSelected: [],
      spanishLinks: [],
      spanishSeo: {},
      processing: false,
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      activeTabIndex: 0,
      redirect: true
    }
  },

  watch: {
    'form.category': {
      handler: 'getProductsSubCategories',
      deep: true
    }
  },

  async created() {
    await this.getProductsCategories()
    await this.getProductsOptions()
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            code: data.code,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            slug: data.slug,
            slug_en: data.slug_en,
            slug_es: data.slug_es,
            installation_tutorial: data.installation_tutorial,
            installation_tutorial_en: data.installation_tutorial_en,
            installation_tutorial_es: data.installation_tutorial_es,
            description: data.description,
            description_en: data.description_en,
            description_es: data.description_es,
            favorite: !!data.favorite,
            status: !!data.status,
            status_en: !!data.status_en,
            status_es: !!data.status_es,
            links: data.links,
            links_en: data.links_en,
            links_es: data.links_es,
            main_image: data.main_image,
            medias: data.medias,
            sub_category: data.sub_category.id,
            category: data.sub_category.category.id,
            related: data.related.map(product => product.id),
            related_en: data.related_en.map(product => product.id),
            related_es: data.related_es.map(product => product.id),
            application_tools: data.application_tools.map(product => product.id),
            application_tools_en: data.application_tools_en.map(product => product.id),
            application_tools_es: data.application_tools_es.map(product => product.id),
            seo: {
              seo_title: data.seo.title,
              seo_description: data.seo.description
            },
            seo_en: {
              seo_title: data.seo_en.title,
              seo_description: data.seo_en.description
            },
            seo_es: {
              seo_title: data.seo_es.title,
              seo_description: data.seo_es.description
            }
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
      await this.getProductsSubCategories()
    },

    async getProductsCategories() {
      const response = await Service.getCategories({ pagination: false, sorter: { column: 'title', asc: true } })

      const options = response.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })

      this.categoriesOptions = [...this.categoriesOptions, ...options]
    },

    async getProductsSubCategories() {
      if (this.form.category) {
        const response = await Service.getSubCategories({ pagination: false, sorter: { column: 'title', asc: true }, category: this.form.category })

        const options = response.data.map(item => {
          return {
            value: item.id,
            label: item.title
          }
        })

        this.subcategoriesOptions = [...options]
      }
    },

    async getProductsOptions() {
      const response = await Service.index({ pagination: false, sorter: { column: 'title', asc: true } })

      this.productsOptions = response.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })

      this.productsOptionsEn = response.data.filter(item => {
        if (item.status_en === 1) {
          return true
        }
      }).map(item => {
        return {
          value: item.id,
          label: item.title_en
        }
      })

      this.productsOptionsEs = response.data.filter(item => {
        if (item.status_es === 1) {
          return true
        }
      }).map(item => {
        return {
          value: item.id,
          label: item.title_es
        }
      })
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      this.processing = true

      const validateYoutube = (link) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
        const match = link.match(regExp)

        return match
      }

      const openModal = (message) => {
        this.modal = {
          show: true,
          title: 'Erro',
          message: message,
          color: 'danger'
        }
      }

      if (this.form.installation_tutorial) {
        const link = validateYoutube(this.form.installation_tutorial)
        if (!link) {
          this.processing = false
          openModal('O tutorial de instalação deve ser um link do youtube')
          return
        }
      }
      if (this.form.installation_tutorial_en) {
        const link = validateYoutube(this.form.installation_tutorial_en)
        if (!link) {
          this.processing = false
          openModal('O tutorial de instalação em inglês deve ser um link do youtube')
          return
        }
      }
      if (this.form.installation_tutorial_es) {
        const link = validateYoutube(this.form.installation_tutorial_es)
        if (!link) {
          this.processing = false
          openModal('O tutorial de instalação em espanhol deve ser um link do youtube')
          return
        }
      }

      let response
      let message

      const data = {
        id: this.$route.params.id,
        code: this.form.code,
        title: this.form.title,
        title_en: this.form.title_en,
        title_es: this.form.title_es,
        slug: this.form.slug,
        slug_en: this.form.slug_en,
        slug_es: this.form.slug_es,
        installation_tutorial: this.form.installation_tutorial,
        installation_tutorial_en: this.form.installation_tutorial_en,
        installation_tutorial_es: this.form.installation_tutorial_es,
        description: this.form.description,
        description_en: this.form.description_en,
        description_es: this.form.description_es,
        favorite: !!this.form.favorite,
        status: !!this.form.status,
        status_en: !!this.form.status_en,
        status_es: !!this.form.status_es,
        medias: this.form.medias.map((media) => media.id),
        sub_category_id: this.form.sub_category,
        seo_title: this.form.seo.seo_title,
        seo_description: this.form.seo.seo_description,
        seo_title_en: this.form.seo_en.seo_title,
        seo_description_en: this.form.seo_en.seo_description,
        seo_title_es: this.form.seo_es.seo_title,
        seo_description_es: this.form.seo_es.seo_description,
        related: this.form.related,
        related_en: this.form.related_en,
        related_es: this.form.related_es,
        application_tools: this.form.application_tools,
        application_tools_en: this.form.application_tools_en,
        application_tools_es: this.form.application_tools_es,
        main_image_id: this.form.main_image && this.form.main_image.length ? this.form.main_image[0].id : null
      }

      data.links = this.form.links.map(link => {
        return {
          title: link.title,
          url: link.url
        }
      })
      data.links_en = this.form.links_en.map(link => {
        return {
          title: link.title,
          url: link.url
        }
      })
      data.links_es = this.form.links_es.map(link => {
        return {
          title: link.title,
          url: link.url
        }
      })

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Produto foi atualizado com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Produto foi cadastrado com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
